import { functions } from "capsule/features"

import { logger } from "./logger"

const resolveDynalink = async (url: string): Promise<string | undefined> => {
  try {
    const result = (await functions().httpsCallable("resolveDynalink")({ url })) as {
      data: { url: string }
    }
    return result.data.url
  } catch (error) {
    logger("Erreur de resolveDynalink:", error)
    return undefined
  }
}

export default resolveDynalink
